export default "__VITE_ASSET__FG28fA7Q__"